/**
 * The default timezone used for all date/time operations.
 * FreightSimple operates in Vancouver timezone.
 */
export const VANCOUVER_TZ = "America/Vancouver";
